import axios from 'axios';
import settings from '@config/site.yml?path=site.{rails_env}.public';
import { currentUserToken, refreshToken } from '@general/authentication'

const apiInstance = axios.create({
  baseURL: settings.apiUrl
})

apiInstance.interceptors.request.use(config => {
  if (config.tokenAuth) {
    if (currentUserToken) {
      config.headers.Authorization = `Bearer ${currentUserToken}`
    } else {
      throw new Error("No currentUserToken available")
    }
  }

  return config
})

apiInstance.interceptors.response.use(null, async (err) => {
  const {
    config: originalRequest,
    response: {status} = {}
  } = err

  if (originalRequest?.tokenAuth && status == 401) { // Token is invalid, let's refresh
    const updatedToken = await refreshToken()
    originalRequest.headers.Authorization = `Bearer ${updatedToken}`
    return await axios(originalRequest)
  } else {
    throw err
  }
})

export default apiInstance
